export const LOCAL_STORAGE_ORDER_CART_KEY = 'fundLiteratureOrderCart'

export function getItemsInCart() {
  const storage = localStorage.getItem(LOCAL_STORAGE_ORDER_CART_KEY)

  const items = (storage && JSON.parse(storage)) || []

  return items
}

export function addToCart(item) {
  let cart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ORDER_CART_KEY))

  if (!cart) {
    cart = []
  }

  cart.push(item)

  localStorage.setItem(LOCAL_STORAGE_ORDER_CART_KEY, JSON.stringify(cart))
}

export function removeFromCart(item) {
  let cart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_ORDER_CART_KEY))

  cart = cart.filter((cartItem) => item.cartId !== cartItem.cartId)

  localStorage.setItem(LOCAL_STORAGE_ORDER_CART_KEY, JSON.stringify(cart))
}
